import { post, get, request } from "./http.js";

// 登录
const indexLogin = (data) => post("web/index/login", data);
//扫码或兑换码核销验证
const indexCheckcode = (data) => post("web/index/checkcode", data);
//确认核销
const indexConfirmsub = (data) => post("web/index/confirmsub", data);

//邀请月嫂表单提交
const inviteYuesao = (data) => post("web/index/invite", data);
//渠道
const inviteGetchannel = (data) => post("web/index/getchannel", data);
//地区
const indexGetcity = (data) => post("web/index/getcity", data);
//地区
const inviteGetparam = (data) => post("yuesaoapplet/invite/getparam", data);


export default {
    indexLogin,
    indexCheckcode,
    indexConfirmsub,

    inviteYuesao,
    inviteGetchannel,
    indexGetcity,
    inviteGetparam
}